import React from 'react';
import PropTypes from 'prop-types';
import { DateLabelWrapper } from './styles';
import Label from '../Label';

const DateLabel = ({
  date,
  size,
  margin,
  isHours,
  noYears,
  isTitleNarrowMedium,
  weight,
  lightSkin,
}) => {
  const formatDate = (datePassed, withHours, deleteYears) => {
    const dateJs = new Date(datePassed);
    const day = (`0${dateJs.getDate().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    const month = (`0${Number(dateJs.getMonth().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })) + 1}`).slice(-2);
    const year = dateJs.getFullYear();
    const hours = (`0${dateJs.getHours().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    const minutes = (`0${dateJs.getMinutes().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    if (withHours) {
      return `${hours}:${minutes}`;
    } else if (deleteYears) {
      return `${day}/${month}`;
    } else {
      return `${day}/${month}/${year}`;
    }
  };

  return (

    <DateLabelWrapper
      margin={margin}
    >
      <Label
        label={`${formatDate(date, null, noYears)}`}
        color={lightSkin ? 'black' : 'white'}
        size={size}
        isTitleNarrowMedium={isTitleNarrowMedium}
        weight={weight}
      />
      {isHours &&
        <Label
          label={`${formatDate(date, isHours)}`}
          color={lightSkin ? 'black' : 'white'}
          size={size}
          margin="10px 0 0"
          isTitleNarrowMedium={isTitleNarrowMedium}
          weight={weight}
        />
      }
    </DateLabelWrapper>
  );
};


DateLabel.propTypes = {
  date: PropTypes.any,
  lightSkin: PropTypes.any,
  size: PropTypes.any,
  margin: PropTypes.any,
  isHours: PropTypes.bool,
  noYears: PropTypes.bool,
  isTitleNarrowMedium: PropTypes.bool,
  weight: PropTypes.string,
};

export default DateLabel;



// WEBPACK FOOTER //
// ./src/components/shared/DateLabel/index.js